import React from 'react'

import { connect } from 'react-redux';

// import NumberFormat from 'react-number-format';
import Checkbox from '@material-ui/core/Checkbox';

import SearchIcon from '@material-ui/icons/Search'
import TextField from '@material-ui/core/TextField';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Notification from '../Notifications'
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import NumberFormat from 'react-number-format';
import CircularProgress from '@material-ui/core/CircularProgress';
import { BillingApi } from '../../api/billing_api';
import { SalesPersonApi } from '../../api/salespeopleApi'
import { UserApi } from '../../api/usersApi'
import { ProductApi } from '../../api/product_api'
import { PurchaseApi } from '../../api/purchaseApi'
import { PayMethodsApi } from '../../api/paymethods_api'
import { InstagramApi } from '../../api/instagram_api'
import Select from 'react-select';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import BillingProductTable from './ProductBillTable'
import FormHelperText from '@material-ui/core/FormHelperText';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import RemoveShoppingCartIcon from '@material-ui/icons/RemoveShoppingCart';
import BuildIcon from '@material-ui/icons/Build';
import _ from "lodash";
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import CategoryIcon from '@material-ui/icons/Category';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


const SALESPERSONAME = 'SpN'
const SALESPERSONID = 'spId'

const NO_IMAGE = "data:image/png;base64,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"
import ReactDOM from 'react-dom';

const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
};


const customStyles = {
    // top: `20%`,
    margin: 'auto',
    width: 750,
    height: 400,
    content: {
        top: '-10%',
        left: '10%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};


const customStyles2 = {
    // top: `20%`,
    margin: 'auto',
    width: 400,
    height: 600,
    content: {
        top: '10%',
        left: '10%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '50%',
        transform: 'translate(-50%, -50%)'
    }
};

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (

        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            decimalScale={2}
            allowNegative={false}
            thousandSeparator={'.'}
            decimalSeparator={','}
            prefix="$"
        />
    );
}


export class PoView extends React.Component {
    constructor(props) {
        super(props)
        this.textInput = React.createRef();
        this.state = {
            salesPeople: [],
            currentSalesPerson: localStorage.getItem(SALESPERSONAME),
            payMethod: 'Efectivo',
            debitPayMethodId: null,
            useCreditNote: false,
            creditNote: null,
            cardInterest: [],
            products: [],
            color: 'disabled',
            codeProd: '',
            total: 0,
            msgType: 'success', // or 'error'
            msg: null,
            customerName: null,
            customerId: null,
            customerDNI: null,
            customerInsta: null,
            gender: "Hombre",
            instagramImage: null,
            custNameError: false,
            custDNIError: false,
            processing: false,
            totalNoInterest: 0,
            creditInterest: null,
            debitInterest: null,
            showCardInterests: false,
            cardInterestList: [],
            cardInterests: {},
            choosenInterest: null,
            payMethodChosen: null,
            payMethodId: null,
            quotes: null,
            creditNoteAmount: null,
            creditNoteId: null,
            refresh: true,
            amountReceived: null,
            amountReturned: null,
            comboCatalog: [],
            isLoading: false,
            showCombos: false,
            codeRepair: 1,
            repairPrice: 0,
            showRepair: false,
            repairs: [],
            prodsAndRepairs: []

        }
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ msg: null })
    }
    componentDidMount() {
        SalesPersonApi.getSalesPayroll()
            .then((response) => {
                return response.data
            })
            .then((data) => {
                let salesPeoples = []
                data.map((item) => {
                    if (item.active) {
                        salesPeoples.push({ 'value': item.id, "label": item.username })
                    }
                })
                this.setState({ salesPeople: salesPeoples })
            })
        PayMethodsApi.getList()
            .then((response) => {
                let cardInterestList = []
                let cardInterests = {}
                response.data.results.map((payMethod) => {
                    if (payMethod.card_type == 'Credito') {
                        const CardData = payMethod.name + ' ' + payMethod.quotes
                        cardInterestList.push({ 'value': payMethod.id, "label": CardData })
                        cardInterests[payMethod.id] = payMethod.amount
                    }
                    else {

                        this.setState({ debitPayMethodId: payMethod.id, debitInterest: payMethod.amount })
                    }
                })
                this.setState({ cardInterestList: cardInterestList, cardInterests: cardInterests })
            })
    }


    handleSalesPersonUpdate = (e) => {
        localStorage.setItem(SALESPERSONAME, e.label)
        localStorage.setItem(SALESPERSONID, e.value)
        this.setState({currentSalesPerson: e.label})
    }

    handlePayMethodUpdate = (e) => {
        let interest = this.state.cardInterests[e.value]
        this.setState({
            showInterest: true, payMethodChosen: e.label,
            choosenInterest: interest, payMethodId: e.value
        })
        this.calculateTotal()

    }


    handleChange = (event) => {
        const payMethod = event.target.value
        if (payMethod == "Debito") {
            this.setState({ quotes: 1, payMethodId: this.state.debitPayMethodId,  payMethodChosen:null, choosenInterest: this.state.debitInterest, showInterest: true})
        }
        else if (payMethod == "Efectivo") {
            this.setState({ showInterest: false, choosenInterest: null })
        }
        else {
            let payMethodChosen = this.state.cardInterestList[0].label
            let payMethodId = this.state.cardInterestList[0].value
            let interest = this.state.cardInterests[this.state.cardInterestList[0].value]
            this.setState({payMethodId: payMethodId, showInterest: true, payMethodChosen: payMethodChosen, choosenInterest: interest })
        }
        this.setState({
            payMethod: payMethod,
            showCardInterests: payMethod != "Efectivo",
            showCreditCardInterests: payMethod == 'Credito',
            total: this.calculateTotal()
        });
    }
    handleGenderChange = (event) => {
        this.setState({ gender: event.target.value });
    }
    setQuotes = (e) => {
        this.setState({ quotes: e.target.value })
    }
    handleCreditNoteClose = (e) => {
        if (this.state.useCreditNote) {
            let total = _.round(_.sum(_.map(this.state.products, d => d.subtotal)), 2)

            if (this.state.payMethod == "Credito" && this.state.choosenInterest) {
                total += _.round(this.state.totalNoInterest * (this.state.choosenInterest / 100), 2)
            }
            else if (this.state.payMethod == "Debito") {
                total += _.round(this.state.totalNoInterest * (this.state.choosenInterest / 100), 2)
            }
            this.setState({ creditNoteAmount: null, total: total })
        }
        this.setState({ useCreditNote: !this.state.useCreditNote })

    }
    setCreditNote = (e) => {
        let total = _.round(_.sum(_.map(this.state.products, d => d.subtotal)), 2)

        if (this.state.payMethod == "Credito" && this.state.choosenInterest) {
            total += _.round(this.state.totalNoInterest * (this.state.choosenInterest / 100), 2)
        }
        else if (this.state.payMethod == "Debito") {
            total += _.round(this.state.totalNoInterest * (this.state.choosenInterest / 100), 2)
        }
        this.setState({ creditNote: e.target.value, total: total, refresh: !this.state.refresh })

    }
    generatePurchase = (event) => {
        this.setState({ processing: true })
        if (this.state.payMethod == "Credito" && (this.state.quotes == 0 || this.state.quotes == null || this.state.payMethodChosen == null)) {
            const msg = 'Seleccionar plan de pago y cuotas '
            this.setState({ processing: false, msg: msg, msgType: 'warning' })
            return
        }

        if (this.state.customerId === null && (this.state.customerDNI != null || this.state.customerName != null)) {
            if (this.state.customerName == '' || this.state.customerName.length < 3) {
                this.setState({ custNameError: true, processing: false })
                return
            }
            if (this.state.customerDNI == null || (this.state.customerDNI.length < 7 || this.state.customerDNI.length > 10)) {
                this.setState({ custDNIError: true, processing: false })
                return

            }
        }
        if(this.state.payMethod == 'Efectivo'){
            if(this.state.amountReceived == null || this.state.amountReceived < this.calculateTotal()){
                this.setState({ processing: false, msg: 'Monto menor al total', msgType: 'error' })
                return
            }
            let diff = this.state.amountReceived - this.calculateTotal()
            if(this.state.amountReturned == null || this.state.amountReturned > diff){
                this.setState({ processing: false, msg: 'Vuelto invalido', msgType: 'error' })
                return
            }
        }
        this.setState({ custDNIError: false, custNameError: false })
        if (this.state.customerId == null && this.state.customerDNI) {
            let newCustomer = {
                dni: this.state.customerDNI,
                last_name: this.state.customerName, gender: this.state.gender
            }
            if (this.state.customerInsta) {
                newCustomer['instagram'] = this.state.customerInsta
            }
            UserApi.createCustomer(newCustomer)
                .then((response) => {
                    this.setState({ customerId: response.data.data.dni })
                    this.purchaseProducts()
                }).catch(error => {
                    console.log(error)
                    this.setState({ processing: false, processing: false, msg: "Error creando cliente", msgType: 'error' })
                });

        }

        else {
            this.purchaseProducts()
        }



    }
    purchaseProducts = () => {
        const purchase = this.state.products.map((product) => {
            return { product_id: product.id, total_items: product.qty }
        });

        let data = { products: purchase, salesperson: localStorage.getItem(SALESPERSONID), pay_method: this.state.payMethod, repairs: this.state.repairs }
        if (this.state.customerId != null) {
            data['customer'] = this.state.customerDNI
        }
        if (this.state.payMethod != "Efectivo") {
            console.log(this.state)
            data['pay_method_id'] = this.state.payMethodId
            data['quotes'] = parseInt(this.state.quotes)
        }

        if (this.state.creditNoteId != null) {
            data['credit_note'] = this.state.creditNoteId
        }
        if(this.state.payMethod == 'Efectivo'){
            data['amount_received'] = parseFloat(this.state.amountReceived)
            data['amount_returned'] = parseFloat(this.state.amountReturned)
        }
        
        PurchaseApi.createPurchase(data)
            .then((response) => {
                this.setState({ processing: false, msg: response.data.message, msgType: 'success' })
                if (response.data.monto != this.calculateTotal()) {
                    const msg = 'CUIDADO El monto ha variado! Monto total a cobrar: ' + response.data.monto
                    this.setState({ processing: false, msg: msg, msgType: 'warning' })
                }
                this.clearProducts()
                this.clearCustomer()

            })
            .catch(error => {
                console.log(error)
                this.setState({ processing: false, msg: error.response.data.message, msgType: 'error' })
            })

    }
    _searchProduct = (prod) => {
        ProductApi.get(prod)
                .then((response) => {
                    let prod = response.data.product
                    let combo = false
                    if(!prod){
                        combo = true
                        prod = response.data.combo
                        prod['product_type'] = 'Combo'
                    }
                    const prods2 = this.state.products
                    if (!prod.active) {
                        this.setState({ msgType: 'info', msg: 'El producto se encuentra inactivo' })
                        return
                    }

                    if (!combo && prod.stock < 1) {
                        this.setState({ msgType: 'info', msg: 'El producto: ' +prod.id + ' no tiene stock' })
                        return
                    }
                    const buyed_product = prods2.find(obj => {
                        return obj.id === prod.id;
                    });
                    if (buyed_product != undefined && prod.stock < buyed_product.qty + 1) {
                        this.setState({ msgType: 'info', msg: 'Producto: ' + prod.id + ' Stock insuficiente' })
                        return
                    }
                    const desc = prod.product_type + ' ' + prod.brand + ' ' + prod.model
                    let newProd = { id: prod.id, desc: desc, price: prod.price, qty: 1, subtotal: prod.price }
                    let prods = this.state.products
                    let prods_and_repairs = this.state.prodsAndRepairs
                    prod = Array.isArray(prods) && prods.find(el => el.id == newProd.id);
                    if (prod) {
                        prod.qty = prod.qty + 1;
                        prod.subtotal = _.round(prod.qty * prod.price, 2)
                    }
                    else {
                        prods.push(newProd)
                        prods_and_repairs.push(newProd)
                        
                    }
                    let total = _.round(_.sum(_.map(prods, d => d.subtotal)), 2)
                    this.setState({ totalNoInterest: total, total: this.calculateTotal(), products: prods, codeProd: '', refresh: !this.state.refresh, prodsAndRepairs:prods_and_repairs })
                })
                .catch((error) => {
                    if (error.response.status == '404') {
                        this.setState({ msgType: 'error', msg: 'El producto no existe!' })
                    }

                })
    }
    searchProduct = e => {
        if (e.keyCode == 13) {
            this._searchProduct(e.target.value)
        }
        else if (!isNaN(e.key)) {
            this.setState({ codeProd: this.state.codeProd + e.key })
        }
        else if (e.keyCode == 8) {
            const prod = this.state.codeProd.slice(0, this.state.codeProd.length - 1)
            this.setState({ codeProd: prod })
        }

    }

    clearProducts = (e) => {
        this.setState({ amountReceived:null, amountReturned: null, totalNoInterest: 0,
                        total: this.calculateTotal(), products: [], creditNoteAmount: null,
                        creditNote: null, creditNoteId: null, useCreditNote: false, prodsAndRepairs: [], repairs: [] })
    }
    getInstagramImage = (instagramUsername) => {

        const username = instagramUsername.replace('@', '')
        UserApi.getCustomerDetails(username)
            .then(response => {
                this.setState({
                    customerDNI: response.data.customer.dni,
                    customerId: response.data.customer.id,
                    gender: response.data.customer.gender,
                    customerName: response.data.customer.last_name,
                    instagramImage: response.data.customer.instagram_profile_pic
                })
                this.setName(response.data.customer.last_name)
            })
            .catch(error => {
                console.log('Usuario nuevo')
            })

            .catch(error => {
                console.log(error)
            })
    }
    createCustomer = () => {
        const newCustomer = {
            instagram: this.state.customerInsta, dni: this.state.customerDNI,
            last_name: this.state.customerName, gender: this.state.gender
        }
        return UserApi.createCustomer(newCustomer)
            .then((response) => {
                return response.data.id
            });
    }
    setName = (e) => {
        if (e == null) {
            this.setState({ customerName: null })
            return
        }
        if (typeof e === 'string' || e instanceof String) {
            this.setState({ customerName: e })
            return
        }
        let value = e.target.value;
        value.replace(/[^A-Za-z\s]/gi, "")
        if (this.state.customerId == null) {
            this.setState({
                customerName: value
            });
        }
    }
    clearCustomer = (e) => {
        this.setName()
        this.setState({ customerId: null, customerDNI: null, customerInsta: null, instagramImage: NO_IMAGE })
    }

    calculateTotal = () => {
        let total = this.state.totalNoInterest
        // discount first the note
        if (this.state.creditNoteAmount) {
            total = _.round(total - this.state.creditNoteAmount, 2)
        }
        // apply interests
        if (this.state.payMethod == "Credito" && this.state.choosenInterest) {
            total += _.round(total * (this.state.choosenInterest / 100), 2)
        }
        else if (this.state.payMethod == "Debito") {
            total += _.round(total * (this.state.choosenInterest / 100), 2)
        }

        return total > 0 ? _.round(total, 2) : 0
    }

    billCombo = (e, comboId) =>{
        e.preventDefault()
            this._searchProduct(comboId)
            this.setState({showCombos: false})

    }
    searchCreditNote = (e) => {
        PurchaseApi.getCreditNote(this.state.creditNote)
            .then(response => {
                const creditNote = response.data
                if (creditNote.used) {
                    this.setState({ processing: false, msg: "Nota de credito ya utilizada", msgType: 'error' })
                    return
                    if (this.state.creditNoteId) {
                        let total = _.round(this.state.total + this.state.creditNoteAmount, 2)
                        this.setState({ total: total, creditNoteId: null, creditNoteAmount: null })
                        return
                    }
                }
                this.setState({ creditNoteAmount: creditNote.total, creditNoteId: creditNote.id })
                this.calculateTotal()
            })
            .catch(error => {
                if (error.response.status == 405) {
                    this.setState({ processing: false, msg: "Nota de credito invalida", msgType: 'error' })
                } else {
                    console.log(error)
                    this.setState({ processing: false, msg: "Error", msgType: 'error' })

                }
                console.log(error)
            })

    }

    loadCombos = () =>{
        ProductApi.getComboReport()
        .then((response) => {
            let rows = []
            response.data.map(function (combo) {
                if(combo.active){
                    let products = combo.items.map(function (item) {
                        return (<div>
                        <Typography display="inline">
                        <b>Cod: </b>{item.product.id} - {item.product.type}  {item.product.brand} {item.product.model}
                        </Typography>
                        <Typography>
                        <b>Cantidad: </b> {item.units}
                        </Typography>
                        </div>)
                    })
                    rows.push([combo.id, combo.brand + '  ' + combo.model, combo.price, products])
                }
            })
            return rows
        })
        .then((data) => {
            this.setState({ comboCatalog: data, showCombos: true })
        })
    }
    handleKeyDown = (e) =>{
        if(e.keyCode === 13) { 
            console.log('Enter key pressed')
      }
    }
    renderRepair = () =>{
        /*
        aca hacer un temp_code_repair
        y un temp_repair_price

        cuando se cierra on click en el boton "agregar"
        se debe pasara a la lista de "products" y vaciar los campos
        */
    //    return (<Table>
    //     <TableHead>
    //         <TableRow>
    //             <TableCell><b>Codigo</b></TableCell>
    //             <TableCell><b>Descripcion</b></TableCell>
    //             <TableCell align="right"><b>Precio</b></TableCell>
    //             <TableCell align="center" ><b>Productos</b></TableCell>
    //         </TableRow>
    //     </TableHead>
    //     </Table>)
        return (<div style={{marginTop:20, marginLeft: 50}}>
                    <div className='col-md-10' style={{marginTop:20, marginLeft: 40}}>
                        <Typography variant="h6" gutterBottom>
                            Ingrese Reparacion
                        </Typography>

                    </div>
                    <div className='col-md-10' style={{marginTop:20, marginLeft: 40}}>
                    <Typography variant="subtitle1" gutterBottom>
                            Codigo
                            <TextField
                            autoFocus
                            style={{ maxWidth: 80, marginTop: -10, marginLeft: 20}}
                            type='number'
                            value={this.state.codeRepair}
                            onChange={(e)=>{this.setState({codeRepair:  e.target.value})}}
                        />
                    </Typography>
                        

                    </div>
                    <div className='col-md-10'>
                    <Typography variant="subtitle1" gutterBottom>
                            Precio
                            <TextField
                            autoFocus
                            style={{ maxWidth: 100, marginTop: -10, marginLeft: 40}}
                            type='number'
                            value={this.state.repairPrice}
                            onChange={(e)=>{this.setState({repairPrice:  e.target.value})}}
                        />
                    </Typography>
                    </div>
                    <Button
                         style={{marginLeft:60, marginTop:30, marginBottom:40}}
                        onClick={this.addRepair}
                        variant="contained"
                        color="primary"
                        disabled={this.state.codeRepair.length < 1 || this.state.repairPrice < 1 }
                    >
                        Generar
                    </Button>
                </div>)
    }
    addRepair =() =>{
        let newRepair = { 'repair_id': parseInt(this.state.codeRepair), 'price': parseInt(this.state.repairPrice) }
        let reps = this.state.repairs
        let existing_repair = reps.find(rep => rep.model == this.state.codeRepair);
        if (existing_repair){
            this.setState({msg: "Reparacion ya agregada!", msgType: 'error'})
            return
        }
        this.state.repairs.push(newRepair)
        let prods = this.state.products
        let total_prods = _.round(_.sum(_.map(prods, d => d.subtotal)), 2)
        let total_repairs = _.round(_.sum(_.map(reps, d => d.price)), 2)
        let total = _.round(total_prods + total_repairs, 2)
        this.setState({ totalNoInterest: total, total: this.calculateTotal(), codeRepair: 0, repairPrice: 1, showRepair: false, refresh: !this.state.refresh })
        this.mergeProdandRepairs(newRepair)
    }
    mergeProdandRepairs = (repair) =>{
        let repair_as_prod = { id: repair.repair_id, desc: 'Reparacion', price: repair.price, qty: 1, subtotal: repair.price }
        let prods_and_repairs = this.state.prodsAndRepairs
        prods_and_repairs.push(repair_as_prod)
        this.setState({prodsAndRepairs: prods_and_repairs })

    }
    renderCombos = () =>{
        return (<Table>
            <TableHead>
                <TableRow>
                    <TableCell><b>Codigo</b></TableCell>
                    <TableCell><b>Descripcion</b></TableCell>
                    <TableCell align="right"><b>Precio</b></TableCell>
                    <TableCell align="center" ><b>Productos</b></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {this.state.comboCatalog.map((combo) => (
                    <TableRow key={combo[0]}>

                        <TableCell><a href={combo[0]} id={combo[0]} onClick={(e) => this.billCombo(e, combo[0])}> <b>{combo[0]}</b></a></TableCell>
                        <TableCell>{combo[1]} </TableCell>
                        <TableCell align="right">
                            <NumberFormat
                                value={combo[2]}
                                displayType={'text'}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                prefix="$"
                            />
                        </TableCell>
                        <TableCell align="right">{combo[3]} </TableCell>
                    </TableRow>

                ))}

            </TableBody>

        </Table>)
    }
    onCloseModal = (e) =>{
        this.setState({showCombos: false, showRepair: false})
    }
    render = () => {
        const total = this.calculateTotal()
        return <div style={{ marginTop: 20 }} onKeyDown={this.handleKeyDown}>
             <Modal
                style={customStyles}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.state.showCombos}
                onClose={this.onCloseModal}

            >
                <Paper elevation={3}>
                    {this.state.showCombos && this.renderCombos()}
                </Paper>
            </Modal>
            <Modal
                style={customStyles2}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.state.showRepair}
                onClose={this.onCloseModal}

            >
                <Paper elevation={3}>
                    {this.state.showRepair && this.renderRepair()}
                </Paper>
            </Modal>
            <div className='col-md-9'>
                <div className='col-md-3' style={{ marginTop: 25, marginLeft: 15 }}>
                    <FormControl className='col-md-12'>
                        <Select
                            name="vendor"
                            value={{ label: this.state.currentSalesPerson }}
                            onChange={(e) => { this.handleSalesPersonUpdate(e) }}
                            options={this.state.salesPeople}
                        />
                        <FormHelperText>Vendedor</FormHelperText>


                    </FormControl>
                </div>

                <div className='col-md-7 col-md-offset-1' style={{ marginTop: 10 }}>

                    <FormControl component="fieldset">
                        <RadioGroup aria-label="position" name="position"
                            value={this.state.payMethod}
                            onChange={this.handleChange} row>
                            <FormControlLabel
                                value="Efectivo"
                                name="Paymethod"
                                control={<Radio color="primary" size="small" />}
                                label="Efectivo"
                                labelPlacement="top"
                            />
                            <FormControlLabel
                                value="Credito"
                                name="Paymethod"
                                control={<Radio color="primary" size="small" />}
                                label="Credito"
                                labelPlacement="top"
                            />
                            <FormControlLabel
                                value="Debito"
                                name="Paymethod"
                                control={<Radio color="primary" size="small" />}
                                label="Debito"
                                labelPlacement="top"
                            />
                            <FormControlLabel
                                style={{ marginTop: 15, marginLeft: 18 }}
                                control={
                                    <Checkbox
                                        checked={this.state.useCreditNote}
                                        // onChange={(e)=>{this.setState({useCreditNote: !this.state.useCreditNote})}}
                                        onChange={this.handleCreditNoteClose}
                                    />
                                }
                                label="NC"
                            />

                        </RadioGroup>


                    </FormControl>

                </div>
                <div className='col-md-12'>
                    {this.state.showCreditCardInterests && <div>
                        <div className='col-md-2' style={{ marginTop: 15 }}>
                            <TextField
                                label="Cuotas"
                                onChange={this.setQuotes}
                                // style={{ marginLeft: 10 }}
                                type="number"
                                value={this.state.quotes}

                            />
                        </div>
                        <div className='col-md-10' style={{ marginTop: 20 }}>
                            <FormControl className='col-md-5'>
                                <Select
                                    name="payMethod"
                                    value={{ label: this.state.payMethodChosen }}
                                    onChange={(e) => { this.handlePayMethodUpdate(e) }}
                                    options={this.state.cardInterestList}
                                />

                                <FormHelperText>Tarjeta y Plan</FormHelperText>


                            </FormControl>

                        </div>
                    </div>}
                    {this.state.useCreditNote && <div className='col-md-5' style={{ marginTop: 10 }}>
                        <TextField
                            label="Nota de Credito"
                            onChange={this.setCreditNote}
                            value={this.state.creditNote}

                        />
                        <IconButton aria-label="Search"
                            onClick={this.searchCreditNote}
                        >
                            <SearchIcon style={{ marginTop: 15 }} />
                        </IconButton>

                    </div>
                    }
                </div>


                <div className='col-md-12' style={{ marginTop: 15 }}>
                </div>
                <div className='col-md-12' style={{ marginTop: 15 }}>

                    <div className='col-md-11'>
                        <IconButton color="primary" component="span"><AddShoppingCartIcon /></IconButton>
                        <InputBase
                            autoFocus
                            placeholder="12345"
                            value={this.state.codeProd}
                            onKeyDown={this.searchProduct} />
                            

                    </div>
                    <div className='col-md-1'></div>
                    <IconButton aria-label="Search"
                        onClick={this.loadCombos}
                                >
                                    <CategoryIcon />
                                </IconButton>
                                <IconButton component="span" onClick={(e)=>{this.setState({showRepair: true})}} style={{ marginTop: 10}}>
                                    <BuildIcon  />
                            </IconButton>
                    <IconButton component="span" onClick={this.clearProducts} style={{marginLeft:15 }}>
                        <RemoveShoppingCartIcon color="disabled" />
                    </IconButton>
                   
                    <BillingProductTable
                        refresh={this.state.refresh}
                        products={this.state.prodsAndRepairs}
                        showInterest={this.state.showCardInterests}
                        payMethod={this.state.payMethod}
                        cardDesc={this.state.payMethodChosen}
                        total={total}
                        totalNoInterest={this.state.totalNoInterest}
                        interest={this.state.choosenInterest}
                        creditNoteDiscount={this.state.creditNoteAmount}
                    />
                </div>
                
                {this.state.payMethod == 'Efectivo'&&
              

                <div className='col-md-10' style={{ marginLeft: 180, marginTop: 10 }}>
                    
                    <div className='col-md-3 col-md-offset-6'>

                        <Typography variant="subtitle1" gutterBottom align='center' >
                            Monto recibido
                        </Typography>
                    </div>
                    <div className='col-md-2' >
                        <TextField style={{ marginTop: -20, marginLeft: -15 }}
                            value={this.state.amountReceived}
                            onChange={(e) => {
                                this.setState({ amountReceived: e.target.value })

                            }}
                            id="amount"
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}

                        />
                    </div>
                    <div className='col-md-3 col-md-offset-6'>

                        <Typography variant="subtitle1" gutterBottom align='center' >
                            Vuelto
                        </Typography>
                    </div>
                    <div className='col-md-2' >
                        <TextField style={{ marginTop: -20, marginLeft: -15 }}
                            value={this.state.amountReturned}
                            onChange={(e) => {
                                this.setState({ amountReturned: e.target.value })

                            }}
                            id="amount"
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}

                        />
                    </div>
                </div>}
                <div className="col-md-1 col-md-offset-10">
                    <Button
                        onClick={this.generatePurchase}
                        variant="contained"
                        color="primary"
                        disabled={(this.state.products.length + this.state.repairs.length) < 1 || this.state.processing}
                    >

                        Generar
                    </Button>
                </div>
                <Notification
                    open={this.state.msg ? true : false}
                    variant={this.state.msgType}
                    message={this.state.msg}
                    onClose={this.handleClose}
                />

            </div>
            <div className='col-md-2' style={{ marginLeft: 50 }}>
                <img src={this.state.instagramImage ? this.state.instagramImage : NO_IMAGE}
                    style={{ width: 80, height: 80, borderRadius: 80 / 2 }} />
            </div>
            <div className='col-md-3'>
                <div className style={{ position: 'relative', display: 'inline-block' }}>

                    <TextField
                        label="Instagram"
                        placeholder="Sin @"
                        onBlur={(e) => this.getInstagramImage(e.target.value)}
                        // onChange={(e) =>this.setState({customerInsta: e.target.value})}
                        onChange={(e) => this.setState({ customerInsta: e.target.value })}
                        style={{ marginLeft: 15 }}
                        type="text"
                        value={this.state.customerInsta ? this.state.customerInsta : ''}

                    />
                    <IconButton component="span" onClick={(e) => {
                        this.setState({
                            customerId: null, customerInsta: null,
                            instagramImage: NO_IMAGE,
                            customerDNI: null, customerName: null
                        })
                    }}
                        style={{ position: 'absolute', right: 0, top: 20, width: 20, height: 20 }}>
                        <DeleteIcon

                        />
                    </IconButton>


                </div>
            </div>
            <div className='col-md-3'>
                <TextField
                    label={this.state.customerId == null ? "NOMBRE Y APELLIDO" : null}
                    onInput={toInputUppercase}
                    helperText={this.state.custNameError ? "Ingrese un nombre valido" : ''}
                    error={this.state.custNameError}
                    disabled={this.state.customerId !== null}
                    onChange={this.setName}
                    style={{ marginLeft: 15 }}
                    type="text"
                    value={this.state.customerName == null ? '' : this.state.customerName}

                />
            </div>
            <div className='col-md-3'>
                <TextField
                    label={this.state.customerId == null ? "DNI SIN PUNTOS" : null}
                    helperText={this.state.custDNIError ? "Ingrese un DNI valido" : ''}
                    error={this.state.custDNIError}
                    onChange={e => {
                        let value = e.target.value;

                        value = value.replace(/[^0-9]/gi, "");
                        this.setState({
                            customerDNI: value
                        });
                    }}
                    disabled={this.state.customerId !== null}
                    style={{ marginLeft: 15 }}
                    type="text"
                    value={this.state.customerDNI == null ? '' : this.state.customerDNI}

                />
            </div>
            <div className='col-md-3' style={{ marginTop: 10 }}>
                <FormControl component="fieldset" style={{ marginLeft: 15 }}>
                    <RadioGroup aria-label="position" name="position" value={this.state.gender} onChange={this.handleGenderChange} row>
                        <FormControlLabel
                            disabled={this.state.customerId !== null}
                            value="Hombre"
                            name="gender"
                            control={<Radio color="primary" size="small" />}
                            label="Hombre"
                            labelPlacement="top"
                        />
                        <FormControlLabel
                            disabled={this.state.customerId !== null}
                            value="Mujer"
                            name="gender"
                            control={<Radio color="primary" size="small" />}
                            label="Mujer"
                            labelPlacement="top"
                        />
                    </RadioGroup>
                </FormControl>

            </div>

        </div >
    }
}


export default PoView;



// WEBPACK FOOTER //
// ./src/components/Billing/Billing.js